module.exports = __webpack_public_path__ + "static/media/new-goodbye.aae98aff.png";